interface BadgeNavigator extends Navigator {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
}

export const syncInboxAppBadge = async (
  unreadCaseCount: number,
  navigatorRef?: BadgeNavigator,
): Promise<void> => {
  const badgeNavigator =
    navigatorRef ??
    (typeof navigator === 'undefined'
      ? undefined
      : (navigator as BadgeNavigator));
  if (!badgeNavigator) return;

  try {
    if (unreadCaseCount > 0 && badgeNavigator.setAppBadge) {
      await badgeNavigator.setAppBadge(unreadCaseCount);
      return;
    }
    if (unreadCaseCount <= 0 && badgeNavigator.clearAppBadge) {
      await badgeNavigator.clearAppBadge();
    }
  } catch {
    // Badging is progressive enhancement and must never block the Inbox.
  }
};
